import { computed, type ComputedRef } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { clampToToday, parseDateParam, parseOptionalDateParam } from '../internal/query-params.ts'

export interface NetWorthQueryState {
  readonly date: ComputedRef<string>
  /** Undefined means the whole history up to `date`. */
  readonly from: ComputedRef<string | undefined>
  setDate(next: string): void
  setFrom(next: string): void
}

/** `date` and `from` live in the URL, so a shared link reopens on the same range. No date may pass today. */
export function useNetWorthQueryState(today: () => string): NetWorthQueryState {
  const route = useRoute()
  const router = useRouter()

  const update = (patch: Record<string, string | undefined>): void => {
    void router.replace({ query: { ...route.query, ...patch } })
  }

  return {
    date: computed(() => clampToToday(parseDateParam(route.query['date'], today()), today())),
    from: computed(() => {
      const from = parseOptionalDateParam(route.query['from'])
      return from === undefined ? undefined : clampToToday(from, today())
    }),
    setDate: (next) => {
      const date = clampToToday(next, today())
      update({ date: date === today() ? undefined : date })
    },
    setFrom: (next) => update({ from: next === '' ? undefined : clampToToday(next, today()) }),
  }
}
